// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__VhzYr","content":"page_content__bgEJF","header":"page_header__c47jF","title":"page_title__j4aqm","subtitle":"page_subtitle__4wZ_Q"};